var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "steps",
    class: _vm.toc
  }, [_c('button', {
    staticClass: "step-circle",
    attrs: {
      "aria-label": _vm.ariaLabelStepNumber
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.emitStepClicked.apply(null, arguments);
      }
    }
  }, [_vm.visited && !_vm.active && !_vm.toc ? _c('div', {
    staticClass: "step-number"
  }, [_c('img', {
    attrs: {
      "src": _vm.checkSrc,
      "alt": "check mark"
    }
  })]) : _c('div', {
    staticClass: "step-number"
  }, [_vm._v("\n      " + _vm._s(_vm.stepNumber) + "\n    ")])]), _vm._v(" "), _vm.hideNotVisited ? _c('div', {
    staticClass: "step-page",
    attrs: {
      "role": "button",
      "aria-label": _vm.stepTitle
    },
    on: {
      "click": _vm.emitStepClicked
    }
  }, [_c('div', {
    staticClass: "step-page-title"
  }, [_vm._v(_vm._s(_vm.stepTitle))])]) : _c('div', {
    staticClass: "step-page",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.emitStepClicked
    }
  }, [_c('div', {
    staticClass: "step-page-title"
  }, [_vm._v(_vm._s(_vm.stepTitle))]), _vm._v(" "), !_vm.visited && !_vm.active && !_vm.toc ? _c('div', {
    staticClass: "not-visited",
    attrs: {
      "aria-describedby": "Not Visited"
    }
  }, [_vm._v("\n      Not Visited\n    ")]) : _vm._e()]), _vm._v(" "), _vm.vertical && !_vm.toc ? _c('div', {
    staticClass: "step-vertical-line"
  }) : !_vm.toc ? _c('div', {
    staticClass: "step-line"
  }) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }